export default (payloads) => {
  return payloads.map((payload, index) => {
    return {
      ...payload,
      order: index,
    };
  });
};
